module.exports = __webpack_public_path__ + "img/5.42c6d85d.jpg";